//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      menu: [
        { title: 'SPORT', url: '/', color: 'primary' },
        { title: 'LIVE BETTING', url: '/live', color: 'primary' },
        { title: 'Premium League', url: '/premium-league', color: 'primary' }
      ]
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    authReady() {
      return this.$store.state.auth.authReady
    },
    balance() {
      if (_.has(this.user, 'balance')) {
        return this.format_money(_.get(this.user, 'balance'), _.get(this.user, 'currency'))
      }
      return null
    },
    headerItems() {
      const header = Array.isArray(this.$store.state.globals_new)
          ? this.$store.state.globals_new.find(obj => obj.handle === 'header')
          : null

      const items = Array.isArray(header?.items) ? header.items : []

      return items
          .filter(link => {
            if (!link.active) return false
            if (!this.authReady && link.visibility === 'auth') return false
            if (link.visibility === 'auth' && !this.user) return false

            return true
          })
          .map(link => ({ ...link }))
          .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
    }

  },
  methods: {
    isActive(item) {
      return this.$route.path.startsWith(this.goTo(item.url))
    },
    action(item) {
      if(!item?.url && item?.action) {
        this.openCashier(item?.action)
      }
    },
    link_styles(item) {
      let styles = 'px-2 transition duration-100 ease-in-out whitespace-nowrap border-b-3 h-full flex items-center border-transparent';
      if (item.url.includes('casino')) {
        styles += ' hover:text-orange-500 hover:border-orange-500';
      } else {
        styles += ' hover:text-primary hover:border-primary';
      }
      if (this.isActive(item)) {
        styles += ' border-primary text-primary';
      } else {
        styles += ' text-white';
      }
      return styles
    },
      goTo(url) {
      if (url.startsWith('http')) return url;
      return this.localePath(`/${url}`)
    },
    async closeIframe() {
      this.loadGlobalIframe('hide_iframe', {}, true)
    },
    async openRightSidebar() {
      this.loadGlobalIframe('hide_iframe', {}, true)
      this.$store.commit('openRightSidebar', true)
      this.$store.commit('betslip/toggleBetslip', false)
    }
  }
}
